import { V1PopupSite } from '../../services/api'
import * as actions from '../actions'
import * as getters from '../getters'
import * as mutations from '../mutations'

const sites = new V1PopupSite()

export default {
  state: {
    popup: null,
  },
  getters: {
    [getters.GET_POPUP]({ popup }) {
      return popup
    },
  },
  mutations: {
    [mutations.POPUP_SET_DATA](state, data) {
      state.popup = data
    },
  },
  actions: {
    async [actions.POPUP_FETCH_DATA]({ state, commit, dispatch }, popupId) {
      const { data } = await sites.byId(popupId)
      commit(mutations.POPUP_SET_DATA, data)
      await dispatch(actions.THEME_INIT, data.firebaseRef)
      // await dispatch(actions.STEPS_INIT, data.firebaseRef)
      return data
    },
    [actions.POPUP_UPDATE]({ commit }, popup) {
      commit(mutations.POPUP_SET_DATA, popup)
      return sites.updateById(popup.id, popup).then(() => {
        commit(mutations.POPUP_SET_DATA, popup)
        // commit(mutations.SITE_TRIGGER_SETTINGS, false)
      })
    },
  },
}
